import { moduleProviderFactory } from "core/providers";
import { NikoFacilityOrderNewFlowInventoryPreview } from "application/niko-facility-order-inventory/pages";
import { InventoryCalculationCutbackEdit } from "application/facility-order/pages";
import { NikoOngoingMissingInventoryEmailEdit } from "application/niko-ongoing-missing-inventory/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.niko-facility-order",
				pattern: "/niko-facility-orders",
                children: [
					{
						name: "master.app.main.niko-facility-order.inventory-preview",
						pattern: "/:id/inventory",
						authorization: "facilityOrderSection.update",
						component: NikoFacilityOrderNewFlowInventoryPreview,
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.INVENTORY",
									route: 'master.app.main.niko-facility-order.inventory-preview'
								}
							],
							back: "master.app.main.niko-facility-order.list",
						},
					},
					{
						name: "master.app.main.niko-facility-order.inventory-edit",
						pattern: "/:facilityOrderId/inventory/:id/isCutback/:isCutback",
						tabTitle:'Edit Inventory Calculation',
						component: InventoryCalculationCutbackEdit,
						authorization: "facilityOrderSection.update",
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.INVENTORY",
									route: 'master.app.main.niko-facility-order.inventory-preview'
								},
								{
									title: "FACILITY_ORDER.CRUMB.INVENTORY_CALCULATION",
									route: 'master.app.main.niko-facility-order.inventory-edit'
								}
							],
							back: "master.app.main.niko-facility-order.inventory-preview",
						},
					},
					{
						name: "master.app.main.niko-facility-order.niko-ongoing-missing-inventory.new-flow-edit-email",
						pattern: "/:facilityOrderId/new-flow/niko-ongoing-missing-inventory",
						component: NikoOngoingMissingInventoryEmailEdit,
						data: {
							crumbs: [
								{
                                    title: "FACILITY_ORDER.CRUMB.INVENTORY",
									route: 'master.app.main.niko-facility-order.inventory-preview'
                                },
                                {
                                    title: "Inventory Continuously Not Received",
                                    route: 'master.app.main.niko-facility-order.niko-ongoing-missing-inventory.new-flow-edit-email'
                                }
							]
						}
					},	
                ]
            }
        ]
    });
})();
